"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var indexPageBaseTheme = function (_a) {
    var _b, _c, _d;
    var MAX_XS = _a.MAX_XS, MAX_S = _a.MAX_S, MAX_M = _a.MAX_M, MIN_M = _a.MIN_M, MAX_L = _a.MAX_L;
    return ({
        index: {},
        siteGroupsBanners: {
            display: "flex",
            justifyContent: "center"
        },
        indexSiteSectionContainer: (_b = {
                display: "grid",
                gridAutoRows: "minmax(6rem, max-content)",
                gridGap: "1rem",
                padding: "2rem",
                gridTemplateColumns: "repeat(5, 1fr)"
            },
            _b[MAX_L] = {
                padding: "2rem 1.5rem",
                gridTemplateColumns: "repeat(4, 1fr)",
            },
            _b[MIN_M] = {
                marginTop: "2.25rem",
            },
            _b[MAX_M] = {
                gridAutoRows: "minmax(4rem, max-content)",
                gridTemplateColumns: "repeat(3, 1fr)",
                gridGap: "0.5rem",
            },
            _b[MAX_S] = {
                gridTemplateColumns: "repeat(2, 1fr)",
                padding: "2rem  1rem",
            },
            _b[MAX_XS] = {
                gridTemplateColumns: "repeat(1, 1fr) !important",
            },
            _b),
        indexSiteSectionIcon: (_c = {
                height: "50px",
                width: "auto",
                display: "flex",
                alignSelf: "center",
                justifySelf: "center",
                "&> img": {
                    height: "100%",
                }
            },
            _c[MAX_S] = {
                marginTop: "1rem",
            },
            _c[MAX_XS] = {
                marginTop: "0.5rem",
                width: "30px",
                height: "30px"
            },
            _c),
        indexSiteSectionHeader: {
            fontSize: "1.875rem"
        },
        indexSiteSectionLink: (_d = {
                display: "flex",
                margin: "1rem",
                flexBasis: "calc(20% - 2rem)",
                flexDirection: "column",
                // gridAutoRows: "minmax(min-content, auto)",
                // gridGap: "0.25rem",
                alignItems: "center",
                alignContent: "start",
                textDecoration: "none",
                overflowWrap: "break-word"
            },
            _d[MAX_L] = {
                flexBasis: "calc(25% - 2rem)",
            },
            _d[MAX_M] = {
                margin: "0.5rem",
                flexBasis: "calc(33.3% - 1rem)",
            },
            _d[MAX_XS] = {
                flexBasis: "100%",
            },
            _d),
        indexSiteSectionTitle: {
            fontWeight: "normal",
            marginTop: "0.25rem",
            textAlign: "center",
        },
        indexSiteSectionTitleWrapper: {
            height: "100%",
            display: "flex",
            flexDirection: "column",
            flex: "1"
        },
        indexSiteSectionDescription: {},
    });
};
exports.default = indexPageBaseTheme;
//# sourceMappingURL=indexPage.js.map